import { Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ControlRoom from "@/pages/ControlRoom";
import { ChatScreen } from "@/modules/chat/ChatScreen";
import { KnowledgeScreen } from "@/modules/knowledge/KnowledgeScreen";
import AddBrain from "@/pages/AddBrain";
import EditBrain from "@/pages/EditBrain";
import AddColony from "@/pages/AddColony";
import Settings from "@/pages/Settings";
import Profile from "@/pages/settings/Profile";
import Subscription from "@/pages/settings/Subscription";
import BCKeyboard from "@/pages/settings/BCKeyboard";
import NotFound from "@/pages/NotFound";
import { BottomTabs } from "@/components/ios/BottomTabs";
import ProjectKnowledge from "@/pages/ProjectKnowledge";

export function AppRouter() {
  return (
    <div className="relative">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/control-room" element={<ControlRoom />} />
        <Route path="/chat" element={<ChatScreen />} />
        <Route path="/chat/:colonyId/:conversationId?" element={<ChatScreen />} />
        <Route path="/knowledge/:colonyId?" element={<KnowledgeScreen />} />
        <Route path="/knowledge" element={<KnowledgeScreen />} />
        <Route path="/add-brain" element={<AddBrain />} />
        <Route path="/edit-brain/:colonyId/:brainId" element={<EditBrain />} />
        <Route path="/add-colony" element={<AddColony />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/profile" element={<Profile />} />
        <Route path="/settings/subscription" element={<Subscription />} />
        <Route path="/settings/keyboard" element={<BCKeyboard />} />
        <Route path="/knowledge/:colonyId" element={<ProjectKnowledge />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomTabs />
    </div>
  );
}